<h1 mat-dialog-title><b>Wijzig gegevens</b></h1>
<mtx-loader [loading]="loading" [type]="'spinner'" [color]="'primary'" [hasBackdrop]="true">
  @if (!isPageDetailsEmpty()) {
    <mat-dialog-content>
      @if (form.controls) {
        <form [formGroup]="form">
          @if (form.controls) {
            <section>
              <mat-form-field appearance="fill" [class.hidden-when-loading]="loading">
                <mat-label>Voertuigsoort</mat-label>
                <mat-select formControlName="vs_vehicleTypeId" (selectionChange)="update('vs_vehicleTypeId')">
                  @for (option of this.getVehicleTypes(); track option) {
                    <mat-option [value]="option.id">{{option.descriptionNl |
                    capitalize}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Merk</mat-label>
                <mat-select formControlName="v_make" (selectionChange)="update('v_make')">
                  @for (option of this.getMakes(); track option) {
                    <mat-option [value]="option.descriptionNl">{{option.descriptionNl |
                    capitalize}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Model</mat-label>
                <mat-select formControlName="v_modelSpecific" (selectionChange)="update('v_modelSpecific')">
                  @for (option of this.getModels(); track option) {
                    <mat-option [value]="option.descriptionNl">{{option.descriptionNl |
                    capitalize}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Carrosserie</mat-label>
                <mat-select formControlName="vs_bodyTypeId" (selectionChange)="update('vs_bodyTypeId')">
                  @for (option of this.getBodyTypes(); track option) {
                    <mat-option [value]="option.id">{{option.descriptionNl |
                    capitalize}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Transmissie</mat-label>
                <mat-select formControlName="vs_transmissionTypeId" (selectionChange)="update('vs_transmissionTypeId')">
                  @for (option of this.getTransmissionTypes(); track option) {
                    <mat-option [value]="option.id">{{option.descriptionNl |
                    capitalize}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Brandstof</mat-label>
                <mat-select formControlName="vs_fuelTypeId" (selectionChange)="update('vs_fuelTypeId')">
                  @for (option of this.getFuelTypes(); track option) {
                    <mat-option [value]="option.id">{{option.descriptionNl |
                    capitalize}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (customVsCylinderVolumeSelected == false) {
                <mat-form-field appearance="fill">
                  <mat-label>Motorinhoud</mat-label>
                  <mat-select formControlName="vs_cylinderVolume" (selectionChange)="update('vs_cylinderVolume')">
                    @for (option of this.getCylinderVolumes(); track option) {
                      <mat-option [value]="option.id">{{option.descriptionNl |
                      capitalize}}</mat-option>
                    }
                    <mat-option [value]="'custom'">Anders...</mat-option>
                  </mat-select>
                </mat-form-field>
              }
              @if (customVsCylinderVolumeSelected == true) {
                <mat-form-field appearance="fill">
                  <mat-label>Motorinhoud (cc)</mat-label>
                  <input formControlName="vs_cylinderVolume" type="number" matInput>
                </mat-form-field>
              }
              @if (customVsPowerSelected == false) {
                <mat-form-field appearance="fill">
                  <mat-label>Vermogen</mat-label>
                  <mat-select formControlName="vs_power" (selectionChange)="update('vs_power')">
                    @for (option of this.getPowerOptions(); track option) {
                      <mat-option [value]="option.id">{{option.descriptionNl |
                      capitalize}}</mat-option>
                    }
                    <mat-option [value]="'custom'">Anders...</mat-option>
                  </mat-select>
                </mat-form-field>
              }
              @if (customVsPowerSelected == true) {
                <mat-form-field appearance="fill">
                  <mat-label>Vermogen (kW)</mat-label>
                  <input formControlName="vs_power" type="number" matInput>
                </mat-form-field>
              }
              <app-form (formChange)="formChange($event)" [show]="['v_dateFirstAdmission']" [fields]="pageDetails.fields">
              </app-form>
            </section>
          }
        </form>
      }
    </mat-dialog-content>
  }
</mtx-loader>

<mat-dialog-actions class="action-buttons" align="start">
  <button mat-raised-button color="warn" (click)="closeDialog()" mat-dialog-close>Annuleren</button>
  <button [disabled]="form.valid == false || loading" mat-raised-button color="primary" (click)="submit()"
  mat-button>Opslaan</button>
</mat-dialog-actions>